// extracted by mini-css-extract-plugin
export default {"pagination_wrap":"Pagination_pagination_wrap__ESpdo","pagination_wrap_selected":"Pagination_pagination_wrap_selected__66Mf8"};